import { USER_ROLES } from '../../config/Routesconfig';

// These account roles already reach document View through the case dashboards.
// Opening the viewer does not grant editing rights; Presentation and the backend
// continue to resolve the current session editor separately.
export const PRESENTATION_ROLES = [...new Set([
  USER_ROLES.superadmin,
  USER_ROLES.admin,
  USER_ROLES.reseller,
  USER_ROLES.clientAdmin,
  USER_ROLES.clientUser,
  USER_ROLES.enterprise,
  'enterprise_client', // Existing backend spelling, alongside the route config spelling.
  USER_ROLES.witness,
  USER_ROLES.guest,
])];
